module.exports = __webpack_public_path__ + "img/mindfulness.53c89d04.png";